import type { LabReferenceImageKind } from './types.js';

export const PRODUCT_VISUAL_REFERENCE_KINDS: readonly LabReferenceImageKind[] = [
  'PRODUCT',
  'PACKAGING',
  'COMBO',
];

export function hasProductVisualReference(kinds: Iterable<LabReferenceImageKind>): boolean {
  const availableKinds = new Set(kinds);
  return PRODUCT_VISUAL_REFERENCE_KINDS.some(kind => availableKinds.has(kind));
}
